import {
    ADD_DICTATION_COMMENTS_SUCCESS,
    FETCH_DICTATION_COMMENTS_START,
    FETCH_DICTATION_COMMENTS_SUCCESS,
    FETCH_DICTATION_COMMENTS_ERROR
} from '../actions/chatActions';

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    dictationComments: []
};

const chatReducer = (state = INIT_STATE, action) => {
    let newState;
    let index;
    switch (action.type) {
        case FETCH_DICTATION_COMMENTS_START:{
            return { ...state, loading: true, submitting:false }
        }
        case FETCH_DICTATION_COMMENTS_SUCCESS: {
            return { ...state, loading: false, error: '', message: '', dictationComments: action.dictationComments };
        }
        case FETCH_DICTATION_COMMENTS_ERROR: {
            return { ...state, loading: false }
        }
        case ADD_DICTATION_COMMENTS_SUCCESS: {
            let newDictationComments = [
                ...state.dictationComments
            ]
            newDictationComments.push(action.comment);
            return { ...state, submitting: true, dictationComments: newDictationComments };
        }
        default:
            return state;
    }
}

export default chatReducer;
